import { mapState, mapGetters } from 'vuex'

import {
	isTopVideo,
	isTopTour360,
	isTopSlideshow
} from '@/helpers/settings'

import brandingMixin from '@/mixins/branding'

import Header from '@/components/header/header.vue'
import MobileMenu from '@/components/mobileMenu/mobileMenu.vue'
import Footer from '@/components/footer/footer.vue'
import Heading from '@/components/heading/heading'
import Lightbox from '@/components/lightbox/lightbox.vue'
import Notification from '@/components/notification/notification.vue'
import FullStickyBg from '@/components/fullStickyBg/fullStickyBg'
import Banner from '@/components/banner/banner.vue'
import Icon from '@/components/icon'

import Video from '@/pages/video/video.vue'
import HMTVideoSlideshow from '@/shared/components/VideoSlideshow'
import HMTHoodQ from '@/shared/components/HoodQ'
import Details from '@/pages/details/details.vue'
import Tour360 from '@/pages/tour360/tour360.vue'
import Gallery from '@/pages/gallery/gallery.vue'
import Slideshow from '@/pages/slideshow/slideshow.vue'
import Floorplan from '@/pages/floorplan/floorplan.vue'
import Documents from '@/pages/documents/documents.vue'
import WalkScore from '@/pages/walkScore/walkScore.vue'
import MapComponent from '@/pages/map/map.vue'
import Contact from '@/pages/contact/contact.vue'
import HMTOpenHouse from '@/shared/components/OpenHouse';

export default {
	mixins: [brandingMixin],
  components: {
		appHeader: Header,
		appFooter: Footer,
		appMobileMenu: MobileMenu,
		appHeading: Heading,
		appLightbox: Lightbox,
		appNotification: Notification,
		appFullStickyBg: FullStickyBg,
		appIcon: Icon,
		appVideo: Video,
		appVideoSlideshow: HMTVideoSlideshow,
		appHoodq: HMTHoodQ,
		appDetails: Details,
		appTour360: Tour360,
		appBanner: Banner,
		appGallery: Gallery,
		appSlideshow: Slideshow,
		appFloorplan: Floorplan,
		appDocuments: Documents,
		appWalkScore: WalkScore,
		appMap: MapComponent,
		appContact: Contact,
		appOpenHouse: HMTOpenHouse
	},
	props: {
		theme: {
			default: 'light',
			type: String
		}
	},
	data () {
    return {
			scrollOffset: 0,
			photosLimit: 12
		}
  },
	computed: {
    ...mapState('tours', ['settings', 'photos']),
		...mapGetters('tour', ['getButtonColor']),
		isTopVideo () {
			return isTopVideo(this.settings)
		},
		isTopTour360 () {
			return isTopTour360(this.settings)
		},
		isTopSlideshow () {
			return isTopSlideshow(this.settings)
		}
	},
	methods: {
		onScrollOffset (offset) {
			this.scrollOffset = offset
		},
		loadMorePhotos () {
			this.photosLimit = 0
		}
	}
}
